<template>
  <!-- lazy loading -->
  <v-skeleton-loader v-if="lazy" type="image"></v-skeleton-loader>

  <!-- tool loading -->
  <div v-else-if="!lazy && !dataReady && forceUnLoading"></div>
  <v-overlay v-else-if="!lazy && !dataReady && forceUnLoading!=true">
    <v-progress-circular indeterminate color="purple" size="70" width="7"></v-progress-circular>
  </v-overlay>

  <v-row v-else :no-gutters="embed">
    <!-- >>>> 勾选箱线图的某个物种 -->
    <v-col cols="12" v-if="groups && groups.length>1">
      <v-chip-group column multiple v-model="ss" active-class="primary" class="mb-4">
        <v-chip small v-for="(group,index) in groups" :key="index">{{group}}</v-chip>
      </v-chip-group>
    </v-col>

    <!-- 非嵌入模式的参数配置 -->
    <v-col v-if="!embed" cols="4">
      <v-card tile outlined>
        <v-card-title>参数配置
          <v-spacer />
          <v-btn v-for="btn in formButtons" :key="btn.code" @click="btn.click" :color="btn.color||'primary'" :text="btn.text||true" :small="btn.small||true">{{btn.name}}</v-btn>
          <v-btn color="primary" @click="onExport">导出</v-btn>
        </v-card-title>
        <v-card-text>
          <chart-option-form ref="paramForm" :items="tool.params" :coder="tool.coder" @change="onParamFormChanged" />
        </v-card-text>
      </v-card>
    </v-col>

    <!-- chart -->
    <v-col :cols="embed ? 12 :8" class="text-center">
      <!-- 嵌入模式： 嵌入设置按钮图标 -->
      <div v-if="embed && !noData" class="text-right mr-3 report-hide">
        <v-btn color="primary" class="rounded-0" @click="paramDialogVisible=true" style="z-index:3;" small>图表设置</v-btn>
      </div>
      <v-row dense>
        <v-col v-for="(group,index) in groups" :key="index" :cols="groups.length==1 ? 12 : 6" v-show="ss.indexOf(index)!=-1">
          <div :id="`${chartElId}_${index}`" :style="chartSizeStyle"></div>
        </v-col>
      </v-row>
    </v-col>

    <!-- 插入扩展组件 -->
    <v-col cols="12" v-if="extCPT">
      <component :is="extCPT" v-model="extCPTValue" v-bind="extCPTProps" ref="extCPT" @change="onExtCPTChanged"></component>
    </v-col>

    <!-- 嵌入设置对话框 -->
    <template v-if="embed">
      <v-dialog v-model="paramDialogVisible" max-width="400" scrollable>
        <v-card :id="`${chartElId}_paramCard`" max-height="480">
          <v-card-title>
            参数配置
            <v-spacer />
            <v-btn color="primary" @click="onExport">导出</v-btn>
            <v-icon dark style="position: absolute;right: 4px;margin-bottom: 100px;" @click="paramDialogVisible=false">mdi-close-circle</v-icon>
          </v-card-title>
          <v-card-text>
            <chart-option-form ref="paramForm" :items="tool.params" :coder="tool.coder" @change="onParamFormChanged" />
          </v-card-text>
        </v-card>
      </v-dialog>
    </template>

    <!-- 导出对话框 -->
    <chart-export-dialog v-model="exportDialogVisible" ref="exportDialog" @ok="onExportOk" />
  </v-row>
</template>
<script>
import ChartOptionForm from '../../ChartOptionForm.vue';
import ChartExportDialog from '../../ChartExportDialog.vue';
import { userFileRead } from '@/plugins/api';
import { DefaultChartOptions, exportSVG, paramConvert, exoprtCharts } from '@/plugins/chart';
import ChartOptionBuilder from '@/plugins/ChartOptionBuilder';
let Highcharts = require('highcharts');
Highcharts.setOptions(DefaultChartOptions);
require('highcharts/highcharts-more')(Highcharts);
export default {
  props: [
    'forceUnLoading',
    'tool', // type: 图表类型, params:图表参数, coder: 图表参数下拉代码
    'paramValue', // 图表参数值
    'dataSourceParam', // 获取数据源所需参数
    'config', // ChartOptionBuilder所需参数
    'exportFileName', 'width', 'height',
    'embed', 'lazy', // 是否嵌入模式, 是否懒加载
    'chartContainerId',
    'formButtons',
    'status' // 图表加载状态
  ],
  data () {
    return {
      // >>>>>>>>>>>>
      groups: [], charts: [], ss: [], srcSeries: null,

      dataReady: false,
      noData: true,
      Highcharts: Highcharts,
      extCPT: null,
      extCPTValue: null,
      dataSource: null, // 图表数据
      chartOption: {}, // 图表option
      exportDialogVisible: false,
      paramDialogVisible: false, // 嵌入模式: 参数设置对话框是否显示
      paramDialogInit: false
    }
  },
  watch: {
    paramDialogVisible (v) {
      if (v) {
        this.$nextTick(() => {
          if (!this.paramDialogInit) {
            this.$refs.paramForm.setFormData(this.paramFormData);
            this.paramDialogInit = true;
          }
          this.Utility.dragDialog(`${this.chartElId}_paramCard`)
        })
      }
    }
  },
  computed: {
    chartSizeStyle () {
      if (this.width && this.height) return `width:${this.width}px;height:${this.height}px`;
      return '';
    },
    chartElId () { return this.chartContainerId || 'chartContainer' }
  },
  components: { ChartOptionForm, ChartExportDialog },
  mounted () { this.init() },
  methods: {
    async init () {
      if (!this.lazy) {
        this.paramFormData = {};
        this.paramOption = null;
        this.paramDialogInit = false;
        this.noData = true;

        await this.initData(); // 加载数据
        if (!this.dataSource || !this.dataSource.length) {
          this.dataReady = true;
          // this.$nextTick(() => {
          //   document.getElementById(this.chartElId).innerHTML = '<p class="text-h3 orange--text">暂无数据</p>';
          // })
        } else {
          this.noData = false;
          await this.initDataAfter(); // 数据加载后处理器
          this.dataReady = true;

          this.$nextTick(async () => {
            this.initParam(); // 初始化参数
            this.initParamAfter(); // 初始化参数后处理器

            this.initParamOption(); // 初始化参数option
            this.initParamOptionAfter(); // 参数option初始化后处理器

            this.initOption(); // 初始化图表option
            this.initOptionAfter(); // 初始化图表option完成后处理器

            await this.initChart(); // 绘制图表
            this.initChartAfter(); // 绘制图表完成后处理器
          })
        }
      }
    },
    async initData () { await userFileRead(this.dataSourceParam).then(res => this.dataSource = res.data) },
    initDataAfter () {
      this.srcSeries = new ChartOptionBuilder(this.tool.type, this.dataSource, this.config).get();
      for (let i = 0, l = this.srcSeries.length; i < l; i++) {
        let series = this.srcSeries[i];
        this.groups.push(series[0].name);
        this.ss.push(i);
      }
    },

    initParam () {
      let formData = {};
      this.tool.params.forEach(item => {
        let value = item.dftValue;
        if (value != null && value != '') {
          let type = item.type;
          if (type == 6) value = parseInt(value);
          else if (type == 9) value = (value == 1 || value == 'true')
          formData[item.code] = value
        }
      })
      if (this.paramValue) for (let k in this.paramValue) formData[k] = this.paramValue[k];
      this.paramFormData = formData;
      if (!this.embed) this.$refs.paramForm.setFormData(formData);

    },
    initParamAfter () { },

    initParamOption () {
      let option = {};
      for (let key in this.paramFormData) {
        let item = this.tool.params.find(p => p.code == key);
        let value = paramConvert(key, this.paramFormData[key]);
        if (item && item.optionCode) this.Utility.deepMerge(option, JSON.parse(item.optionCode.replaceAll('\\${value}', value)));
        else this.Utility.deepMerge(option, value);
      }
      this.paramOption = option;
    },
    initParamOptionAfter () { },

    initOption () {
      let boxplotOption = this.getBoxplotOption();
      this.Utility.deepMerge(this.chartOption, boxplotOption, this.paramOption);
    },
    // >>>>>>>>>>>>>>>>
    initOptionAfter () {
    },

    // >>>>>>>>>>>>>>>
    initChart () {
      let dcs = this.Highcharts.getOptions().colors;
      let tcs = [];
      for (let i = 0; i < 10; i++) tcs.push(...dcs);
      for (let i = 0; i < this.groups.length; i++) {
        let option = this.Utility.clone(this.chartOption);
        let series = this.srcSeries[i];
        series[0].data.forEach((d, i) => d.color = tcs[i]);
        let scatter = series[1];
        if (scatter) scatter.data.forEach(d => d.color = tcs[d.x])
        let dataOption = {
          chart: { events: { render: this.processBoxColor } },
          series: series,
          title: { text: this.groups[i] },
          xAxis: { title: '', labels: { formatter: (a) => series[0].data[a.value].name } }
        };
        this.Utility.deepMerge(option, dataOption);
        this.charts[i] = this.Highcharts.chart(`${this.chartElId}_${i}`, option);
      }
    },
    initChartAfter () { },


    // ------------------ 导出
    // >>>>>>>>>>>>>>>>
    onExport () {
      if (!this.ss.length) {
        this.$message.error('请选择一个图表');
        return;
      }
      let svgNode = this.charts[0].container.children[0];
      let w = svgNode.width.baseVal.value, h = svgNode.height.baseVal.value;
      this.exportDialogVisible = true;
      this.$nextTick(() => this.$refs.exportDialog.setSourceSize({ width: w, height: h }));
    },
    onExportOk (formData) {
      let option = { ...formData, filename: this.exportFileName };
      if (this.ss.length == 1) {
        exportSVG(this.charts[this.ss[0]].container.children[0], option);
      } else {
        let svgNodes = [], fileNames = [];
        this.ss.forEach(idx => {
          svgNodes.push(this.charts[idx].container.children[0]);
          fileNames.push(this.groups[idx]);
        })
        exoprtCharts(svgNodes, option, fileNames);
      }
      this.exportDialogVisible = false;
    },

    // --------------- 图表参数处理
    // >>>>>>>>>>>>>>
    onParamFormChangedBefore (e, item) {
      if (item.code === 'colors') {
        this.processColor(e.split(','));
        return false;
      }
    },
    onParamFormChanged (e, item) {
      let r1 = this.onParamFormChangedBefore(e, item);
      if (r1 === false) return;
      let value = paramConvert(item.code, e);
      let option = value;
      if (item.optionCode) option = JSON.parse(item.optionCode.replaceAll('\\${value}', value));
      for (let i = 0; i < this.groups.length; i++)this.charts[i].update(option);
      this.onParamFormChangedAfter(value, item);
    },
    onParamFormChangedAfter () { },

    // --------------- 扩展组件
    onExtCPTChanged () { },


    // =================== 获取箱线图的默认option 
    getBoxplotOption () {
      return {
        chart: { animation: false, type: 'boxplot', zoomType: 'xy' },
        credits: { enabled: false },
        title: { text: '' },
        legend: { enabled: false },
        tooltip: { headerFormat: '', pointFormat: '{point.name}<br/>low:{point.low:.2f}<br/>q1:{point.q1:.2f}<br/>median:{point.median:.2f}<br/>q3:{point.q3:.2f}<br/>high:{point.high:.2f}' },
        yAxis: { title: { text: null }, gridLineWidth: 0, tickWidth: 1, tickColor: '#00000066', tickLength: 5, lineWidth: 1, lineColor: '#00000066' },
        xAxis: {
          tickInterval: 1,
          tickColor: '#00000066', tickLength: 5, tickWidth: 1, lineWidth: 1, lineColor: '#00000066',
          labels: { style: { textOverflow: 'none', whiteSpace: 'nowrap' } },
          plotOptions: {
            series: { stickyTracking: false, },
            scatter: { tooltip: { headerFormat: '', pointFormat: '{point.name}: {point.y:.2f}' } }
          }
        }
      }
    },
    // =================== 处理每组箱体颜色
    processColor (cs) {
      let tcs = [];
      for (let i = 0; i < 10; i++) tcs.push(...cs);
      for (let i = 0; i < this.groups.length; i++) {
        let series = this.srcSeries[i];
        series[0].data.forEach((d, i) => d.color = tcs[i]);
        let scatter = series[1];
        if (scatter) { scatter.data.forEach(d => d.color = tcs[d.x]) }
        let opt = { series: series };
        this.charts[i].update(opt);
      }
    },
    // ================== 处理箱体颜色
    processBoxColor (e) {
      let a = e.target.container;
      let b = a.getElementsByClassName('highcharts-point');
      if (b && b.length) {
        b.forEach(item => {
          let c = item.getElementsByClassName('highcharts-boxplot-box');
          if (c && c.length) {
            let color = c[0].getAttribute('stroke');
            c[0].setAttribute('fill', color + '99');
          }
        })
      }
    }
  }
}
</script>